import React from 'react'
import url from 'front-end-core/core/url'
import { MW_ANALYTICS } from 'constants/controllers'
import dealTypes from 'constants/mw-deal-types'
import { intervals } from 'constants/mw-analytics-intervals'
import Filter from './Filter'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const filterOptions = {
  i: { title: 'Time Period', options: intervals },
  t: { title: 'Deals', options: dealTypes }
}

const Filters = props => {
  const aol = useSelector(selectAolName)
  const { query } = props
  const filters = Object.keys(filterOptions).reduce((acc, key) => {
    const options = filterOptions[key].options.map(option => ({
      ...option,
      url: url(MW_ANALYTICS, { aol }, { ...query, [key]: option.value })
    }))

    return {
      ...acc,
      [key]: { ...filterOptions[key], options, value: query[key] }
    }
  }, {})

  return (
    <div className='bg-white pa6 min-h-100'>
      {Object.keys(filters).map(key => (
        <Filter key={key} {...{ ...filters[key] }} />
      ))}
    </div>
  )
}

export default Filters
